import { App } from "./app.js";

const root = document.getElementById("app");
new App(root);
